
//-----------------StyleSheet-----------------
import PageStyle from "@/styles/pages/career/view-job/_index.module.scss";
import NewPageStyle from "@/styles/pages/career/new-view-job/_index.module.scss";
import ButtonStyle from '@/styles/components/button/_index.module.scss';

//-----------------StyleSheet-----------------

//-----------------Components-----------------
import Image from "next/image";
import Link from 'next/link';

//-----------------Components-----------------


//-----------------Custom Components--------------
import Button from '@/components/button';
//-----------------Custom Components--------------


//----------------- Images --------------------
import BlueLogo from "public/images/logo/Bluelogo.png";
import fb from "public/icons/fb.png";
import twitter from "public/icons/twitter.png";
import linkedin from "public/icons/linkedin.png";

//----------------- Images --------------------
export {PageStyle, Image, Link, Button, BlueLogo, fb, twitter,linkedin, NewPageStyle, ButtonStyle}

export { axios, API, AutocompleteError, HelmetMeta, handleOtherResponseCode,  Loading, NextServerCookies, useTranslation,
        DataFromUrl, REDIRECT, SUCCESS_REPONSE_CODE, TRANSLATION, toastr, useRouter, useRef, UNPROCESSABLE_ENTITY_RESPONSE_CODE, 
        useState, useEffect, Yup, Tooltip, CustomToastrAction, CommonAction, Checkbox, QUESTION_TYPES, DefaultCheckbox, HoverCheckbox, CheckedCheckbox} from '@/imports-files/common/common';

export {APPLICATION_FILE_SIZE_LIMIT, CV_FILE_EXTENSIONS, OTHER_FILE_EXTENSIONS, applyJobInitialValues, viewJobValidation, submitAnswerInitialValues, submitAnswerSchema} from '@/constants/pages/jobs/view-job';

export {onAddCandidateRemoveFile} from '@/actions/pages/candidates/add-candidate'

export {activeViewClass, copyToClipboard, cvErrors, handleFormSubmit, jobApplicationTokenSubmit, 
        closeDropDown, onApplyClick, onCancel, otherErrors, onRemoveFile, onFileChange, viewDescription, 
        updatePage, updateApplicationData, without_cv_condition_passes, redirectToCarrerPage, submitScreeningQuestions, validAnswers} from '@/actions/pages/jobs/view-job';
        
export {JobCommon} from '@/services/pages/clients/jobs/common';
export {SendRequest} from '@/services/common/send-request';
export {JobApplication} from '@/services/pages/jobs/view-job';
export { ErrorPages } from "@/actions/common/render_error_loading";

export { DropboxChooser, GoogleChooser, EXTENSION_COMMON } from 'react-file-picker-providers';
export { DuplicateEmailModal } from '@/components/duplicate-email-modal'


export { Header}  from '@/components/careers/header';
export { Footer } from '@/components/careers/footer';
export { CustomizeCareerAction } from '@/actions/pages/clients/careers/customize-career-page';
export { default as GoogleFontLoader } from 'react-google-font-loader';
